import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

const POLL_INTERVAL = 2000

export default class extends Controller {
  static get values() { return { url: String, emailVerified: Boolean }; }

  connect() {
    this.stopped = false
    this.originalPathname = window.location.pathname

    // The domain page mounts this with no url at all and has never polled anything. Without this
    // guard a String value's "" default would make it poll its own path.
    if (!this.hasUrlValue) { return; }
    if (this.emailVerifiedValue) { return; }

    this.check()
  }

  // Two things retire the chain. Turbo keeps the timer alive across a visit, so the poll notices
  // the browser has moved on; and disconnect stops it outright, which is what a same-element
  // reconnect needs - otherwise the old chain keeps polling alongside the new one.
  disconnect() {
    this.stopped = true
    clearTimeout(this.pollTimeoutId)
    this.pollTimeoutId = null
  }

  check() {
    if (this.stopped) { return; }
    if (window.location.pathname !== this.originalPathname) { return; }

    // SubdomainController answers html, and feature_blocked redirects rather than reporting on it;
    // $http asked for JSON by default.
    const options = RequestHelper.defaultRequestOptions()
    options.headers = Object.assign({}, options.headers, { "Accept": "application/json" })

    fetch(this.urlValue, options).
      then(response => {
        if (!response.ok) { throw new Error(`Verification check failed (${response.status})`); }
        return response.status === 200 ? response.json() : {}
      }).
      then(status => {
        // The request outlives disconnect, so its answer has to be dropped rather than acted on.
        if (this.stopped) { return; }

        if (status && status.email_verified) {
          window.location.reload()
        } else {
          this.pollTimeoutId = setTimeout(() => this.check(), POLL_INTERVAL)
        }
      }).
      catch(this.logFailedCall)
  }

  logFailedCall(response) {
    console.warn(response)
  }
}
